import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { Helmet } from 'react-helmet';
import logo from './img/logo.png';

const Root = () => (
    <>
        <Helmet>
            <link rel="icon" href={logo} />
        </Helmet>
    <App />
    </>
);

const rootElement = document.getElementById('root');

if (!rootElement) {
    throw new Error("Root element '#root' not found");
}

createRoot(rootElement).render(<Root />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
